import { render, staticRenderFns } from "./social-links.vue?vue&type=template&id=39478052"
import script from "./social-links.vue?vue&type=script&lang=ts"
export * from "./social-links.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports